import styled from 'styled-components';
import { ifProp, palette } from 'styled-tools';

import { fontSize, FontSizes, fontWeight, FontWeights, PrimaryButton, Text } from '@calm-web/design-system';

export const Wrapper = styled.div<{ $isVisible: boolean }>`
	align-items: center;
	display: ${p => (p.$isVisible ? 'flex' : 'none')};
	flex-direction: column;
	grid-column-gap: 1rem;

	@media screen and (min-width: 1200px) {
		align-items: center;
		flex-direction: row;
		justify-content: space-between;
	}
`;
export const CopyContainer = styled.div`
	align-items: center;
	display: flex;
	flex-direction: column;
	padding-top: 32px;

	@media screen and (min-width: 1200px) {
		padding-top: 0;
		width: 420px;
	}
`;
export const Heading = styled(Text).attrs({
	color: 'blackAlpha80',
	el: 'h3',
	weight: FontWeights.Medium,
	noMargin: true,
})`
	&&& {
		font-size: 20px;
		line-height: 150%;
		margin-bottom: 8px;

		@media screen and (min-width: 1200px) {
			font-size: 22.5px;
		}
	}
`;

export const Copy = styled(Text).attrs({
	color: 'blackAlpha80',
	el: 'p',
	noMargin: true,
	size: FontSizes.base,
})`
	&&& {
		margin-bottom: 32px;

		@media screen and (min-width: 1200px) {
			margin-bottom: 48px;
		}
	}
`;
export const SampleCta = styled.div`
	background: rgba(26, 62, 111, 0.1);
	border-radius: 10px;
	color: ${palette('buttonBlue')};
	display: inline-block;
	${fontSize(FontSizes.sm)}
	${fontWeight(FontWeights.Medium)}
	margin-bottom: 12px;
	padding: 6px 12px;
`;
export const ContentTitle = styled(Text).attrs({
	styleAs: 'h4',
	color: 'blackAlpha80',
	noMargin: true,
	weight: FontWeights.Demi,
	size: FontSizes.base,
})``;

export const ContentLink = styled.a`
	text-decoration: none;
`;

export const ContentAuthor = styled(Text).attrs({
	styleAs: 'h5',
	color: 'blackAlpha80',
	noMargin: true,
	weight: FontWeights.Medium,
	size: FontSizes.sm,
})``;
export const AppImage = styled.div<{
	borderBakedIn?: boolean;
}>`
	border-top-left-radius: 40px;
	border-top-right-radius: 40px;
	border: ${ifProp('borderBakedIn', 'none', '8px #dedede solid')};
	border-bottom: none;
	box-sizing: content-box;
	height: 334px;
	overflow: hidden;
	position: relative;
	width: 252px;
	flex: 0 0 334px;

	@media screen and (min-width: 1200px) {
		align-self: end;
		height: 460px;
		width: 320px;
		flex: ${ifProp('borderBakedIn', '0 0 334px', '0 0 320px')};
	}
`;
export const AppCopy = styled.div`
	bottom: 0;
	display: flex;
	flex-direction: column;
	padding: 0 30px 48px;
	position: absolute;
	left: 0;
	right: 0;
`;
export const AppTitle = styled(Text).attrs({
	color: 'white',
	styleAs: 'h4',
	noMargin: true,
	size: FontSizes.base,
	weight: FontWeights.Demi,
})`
	&&& {
		margin-bottom: 8px;
	}
`;
export const AppSubheading = styled(Text).attrs({
	color: 'white',
	styleAs: 'h5',
	noMargin: true,
	size: FontSizes.sm,
	weight: FontWeights.Medium,
})``;

export const SlideCTA = styled(PrimaryButton)`
	margin-top: 45px;
	margin-bottom: 60px;
	width: 100%;
`;
